/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.title[_ngcontent-%COMP%]{display:flex;align-items:center;margin-bottom:10px}.title[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:2.5rem;text-transform:capitalize}.title[_ngcontent-%COMP%]   .add-video-btn[_ngcontent-%COMP%]{margin-left:auto}.season-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;margin-top:20px}.season-list-item[_ngcontent-%COMP%]{display:block;flex:1 1 auto;margin:0 5px 10px}.season-list-item[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin-right:8px}"];
export { styles as styles };
